import { tutorPrices, tutorRatings } from '../pages/student/FindTutor/data'

const getFindTutorFilters = (filters) => {
  const priceRange =
    filters.price !== '_' ? tutorPrices.find((price) => price.value === filters.price) : undefined
  const ratingRange =
    filters.rating !== '_'
      ? tutorRatings.find((price) => price.value === filters.rating)
      : undefined

  return {
    ...filters,
    price: undefined,
    rating: undefined,
    class_banner_category:
      filters.class_banner_category === '_' ? undefined : filters.class_banner_category,
    languages: filters.languages === '_' ? undefined : filters.languages,
    class_banner_level: filters.class_banner_level === '_' ? undefined : filters.class_banner_level,
    timezone: filters.timezone === '_' ? undefined : filters.timezone,
    country_of_origin: filters.country_of_origin === '_' ? undefined : filters.country_of_origin,
    country_of_residence:
      filters.country_of_residence === '_' ? undefined : filters.country_of_residence,
    time_preferences: filters.time_preferences || undefined,
    search: filters.search || undefined,
    price_per_class__range: priceRange?.value || undefined,
    price_per_class__gte:
      typeof priceRange?.value === 'string' && !priceRange.value.includes('_')
        ? priceRange.value
        : undefined,
    overall_rating__range: ratingRange?.value || undefined,
  }
}

export default getFindTutorFilters
